import session from '@/shared/session'

// initial state
const state = {
	current : {},
}

// getters
const getters = {}

// actions
const actions = {
	accessoryOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/accessorys/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	accessoryDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/accessorys/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	accessoryCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/accessorys/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	accessoryUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/accessorys/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	accessoryRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/accessorys/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filteraccessorys ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/accessorys/get_filtered_accessorys/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    accessoryStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/accessorys/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	activeAccessorys({ commit }) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/accessorys/get_active_accessorys/', {
				headers: {
					"Authorization": "Token " + localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data;
				resolve(data);
			})
			.catch(errors => {
				resolve(errors.response.data);
			});
		});
	},	
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
